export default __webpack_public_path__ + "static/media/54_desktop.823cb6cc.jpg";